// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 属性基类 实体类
 * 属性基类
 */
export abstract class BaseAttribute extends BEBaseElement {
  /** 数据类型 : 定义属性的数据类型，如果非原始类型，需要提供全名 */
  private _dataType: EnumDataType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumDataType) {
    this._dataType = value;
  }

  /** 引用类型 : 引用类型，当数据类型为引用的时候有效 */
  private _referenceType: string;

  /** 设置：引用类型 */
  public get referenceType() {
    return this._referenceType;
  }

  /** 获取：引用类型 */
  public set referenceType(value: string) {
    this._referenceType = value;
  }

  /** 是否是集合 : 是否是集合，集合时DataType使用内联类型 */
  private _isCollection: boolean;

  /** 设置：是否是集合 */
  public get isCollection() {
    return this._isCollection;
  }

  /** 获取：是否是集合 */
  public set isCollection(value: boolean) {
    this._isCollection = value;
  }

  /** 是否只读 : 是否只读，只读不生成Setter访问器 */
  private _isReadOnly: boolean;

  /** 设置：是否只读 */
  public get isReadOnly() {
    return this._isReadOnly;
  }

  /** 获取：是否只读 */
  public set isReadOnly(value: boolean) {
    this._isReadOnly = value;
  }

  /** 分组名称 : 属性分组名称 */
  private _groupName: string;

  /** 设置：分组名称 */
  public get groupName() {
    return this._groupName;
  }

  /** 获取：分组名称 */
  public set groupName(value: string) {
    this._groupName = value;
  }

  constructor() {
    super();
    this._dataType = EnumDataType.String;
    this._referenceType = '';
    this._isCollection = false;
    this._isReadOnly = false;
    this._groupName = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.dataType = element.dataType;
      this.referenceType = element.referenceType;
      this.isCollection = element.isCollection;
      this.isReadOnly = element.isReadOnly;
      this.groupName = element.groupName;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.dataType = json.DataType as EnumDataType;
    this.referenceType = json.ReferenceType;
    this.isCollection = json.IsCollection;
    this.isReadOnly = json.IsReadOnly;
    this.groupName = json.GroupName;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DataType = this.dataType;
    json.ReferenceType = this.referenceType;
    json.IsCollection = this.isCollection;
    json.IsReadOnly = this.isReadOnly;
    json.GroupName = this.groupName;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('代码属性', 'dataType', '数据类型', EnumDataType.Reference, this.dataType, true, '定义属性的数据类型，如果非原始类型，需要提供全名', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('代码属性', 'referenceType', '引用类型', EnumDataType.String, this.referenceType, true, '引用类型，当数据类型为引用的时候有效', '', 'PGRowDataTypeValue:all');
    context.addRow('代码属性', 'isCollection', '是否是集合', EnumDataType.Bool, this.isCollection, true, '是否是集合，集合时DataType使用内联类型', '', '');
    context.addRow('代码属性', 'isReadOnly', '是否只读', EnumDataType.Bool, this.isReadOnly, true, '是否只读，只读不生成Setter访问器', '', '');
    context.addRow('代码属性', 'groupName', '分组名称', EnumDataType.String, this.groupName, true, '属性分组名称', '', '');
  }
}
